import ndjsonStream from 'can-ndjson-stream';

const API_BASE_URL = process.env.REACT_APP_MONITORING_BASE_URL || 'https://monitor.piosphere.ai';

export const getMetricsByNodeId = async (nodeId) => {
  try {
    const metricsEndpoint = process.env.REACT_APP_MONITORING_METRICS_ENDPOINT || '/v1/stream/metrics';
    const response = await fetch(`${API_BASE_URL}${metricsEndpoint}?node_id=${nodeId}`);

    if (!response.ok) {
      // Handle specific error codes gracefully
      if (response.status === 404) {
        return {
          streamReader: null,
          error: 'Node metrics not available (node not found)'
        };
      }
      if (response.status >= 500) {
        return {
          streamReader: null,
          error: 'Server error - metrics temporarily unavailable'
        };
      }
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    // Check if response has a body
    if (!response.body) {
      return {
        streamReader: null,
        error: 'No response body received'
      };
    }

    const streamReader = await ndjsonStream(response.body).getReader();

    return {
      streamReader,
      error: null
    };
  } catch (error) {
    console.debug('Error setting up metrics stream:', error.message);
    return {
      streamReader: null,
      error: error.message
    };
  }
};

export const getAllMetrics = async () => {
  try {
    const allMetricsEndpoint = process.env.REACT_APP_MONITORING_ALL_METRICS_ENDPOINT || '/v1/stream/metrics/all';
    const response = await fetch(`${API_BASE_URL}${allMetricsEndpoint}`);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const streamReader = await ndjsonStream(response.body).getReader();

    return {
      streamReader,
      error: null
    };
  } catch (error) {
    console.error('Error setting up all metrics stream:', error);
    return {
      streamReader: null,
      error: error.message
    };
  }
};

export const getAllContainerDetails = async (nodeId) => {
  try {
    const containerDetailsEndpoint = process.env.REACT_APP_MONITORING_CONTAINER_DETAILS_ENDPOINT || '/v1/get_all_container_details';
    const response = await fetch(`${API_BASE_URL}${containerDetailsEndpoint}?node_id=${nodeId}`);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    return {
      data,
      error: null
    };
  } catch (error) {
    console.error('Error fetching container details:', error);
    return {
      data: null,
      error: error.message
    };
  }
};

export const getContainerMetrics = async (nodeId, containerName) => {
  try {
    const containerMetricsEndpoint = process.env.REACT_APP_MONITORING_CONTAINER_METRICS_ENDPOINT || '/v1/stream/container/metrics';
    const response = await fetch(`${API_BASE_URL}${containerMetricsEndpoint}?node_id=${nodeId}&container_name=${encodeURIComponent(containerName)}`);

    if (!response.ok) {
      // Handle specific error codes gracefully
      if (response.status === 404) {
        return {
          streamReader: null,
          error: 'Container metrics not available (container not found)'
        };
      }
      if (response.status >= 500) {
        return {
          streamReader: null,
          error: 'Server error - metrics temporarily unavailable'
        };
      }
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    // Check if response has a body
    if (!response.body) {
      return {
        streamReader: null,
        error: 'No response body received'
      };
    }

    const streamReader = await ndjsonStream(response.body).getReader();

    return {
      streamReader,
      error: null
    };
  } catch (error) {
    console.debug('Error setting up container metrics stream:', error.message);
    return {
      streamReader: null,
      error: error.message
    };
  }
};

